import styled from 'styled-components';

export default styled.div`
  position: fixed;
  bottom: 1rem;
  text-align: center;
  margin: 0 auto;
  text-align: center;
  width: 100%;
  pointer-events: none;
  z-index: 1000;
`;
